import { useIntl } from 'react-intl'
import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { TablesCodeBookBba } from "./TablesCodeBookBba";
import { RootState } from '../../../setup';
import { shallowEqual, useSelector } from 'react-redux'
import { MenuComponent } from '../../../_metronic/assets/ts/components'
import { UserModel } from '../auth/models/UserModel'
import { apiUrl as host } from '../../../setup/appConfig'
import { authFetch } from '../auth/redux/AuthFetch'
type Props = {
  className: string
}

export interface IState {
  param?: string;
  param1?: boolean
}
export interface CodeBook {
  id: number;
  longNameCodeBook: string;
  shortNameCodeBook: string;
  address: string;
  username: string;
  lastDateModified: string;
}
class CodeBookClass {

  ShortNameCodeBook: string;
  LongNameCodeBook: string;
  Address: string;
  constructor(LongNameCodeBook: string, ShortNameCodeBook: string, Address: string) {
    this.LongNameCodeBook = LongNameCodeBook;
    this.ShortNameCodeBook = ShortNameCodeBook;
    this.Address = Address;
  }

}

const CodeBookBbaAddAndSearch: React.FC<Props> = ({ className }): any => {

  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel

  const [LongName, setLongName] = useState('')
  const [ShortName, setShortName] = useState('');
  const [Address, setAddress] = useState('');

  const [CodeArray, fillCodeBookArray] = useState<CodeBook[]>([])
  const intl = useIntl();

  var CodeBookArray: CodeBook[] = [];
  const onKeyDownHandler = (e: any) => {
    if (e.keyCode === 13) {
      getCodeBook();
    }
  };
  //value = { ibanValue }
  //onChange = { onChangeAccountIban }

  const onChangeLongName = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setLongName(event.target.value);
  }


  const onChangeShortName = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setShortName(event.target.value);

  }
  const onChangeAddress = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setAddress(event.target.value);

  }




  const [showNoResultMessage, setShowNoResultMessage] = useState('');
  const resetInputField = () => {
    setLongName('');
    setShortName('');
    setAddress('');
  }





  function showToastMessage() {

    toast('Nema podataka u bazi...', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2000, type: 'error' });
  }




  function addCodeBook(LongName: string, ShortName: string, Address: string) {

    const data = {
      LongNameCodeBook: LongName,
      ShortNameCodeBook: ShortName,
      Address: Address,
      Username: user.username,

    };

    if (LongName === '' || ShortName === '' || Address === '') {
      alert('Molimo vas upišite vrijednosti za filtere pretrage!')
    }
    else {
      const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
      const requestoptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ClientId: clientId,
          Authorization: accessToken,
        },

        // body: JSON.stringify(x.toString()),
        body: JSON.stringify(data)
        //data
      }
      var endpoint = `${host}/inquiry/addCodeBook`;

      authFetch(
        endpoint,
        requestoptions
      ).then(res => res.json())
        .then(response => {
          if (response != null) {
            alert('Uspješno upisan novi zapis u šifarnik');
          }
          else {
            alert('Došlo je do greške prilikom pokušaja upisa u bazu, molimo vas da pokušate ponovo. Ukoliko se problem ponovi obratite se IT-u');
          }






        })
        .catch(error => {
          toast('Greška: ', error.toString());
        });



    }
  }

  function getCodeBook() {


    var spin = document.querySelector("#search-spin");
    var zoom = document.querySelector("#search-zoom");

    if (spin != null && zoom != null) {
      spin.removeAttribute("hidden");
      zoom.setAttribute("hidden", "true");
    }


    if (LongName === '' && ShortName === '' && Address === '') {
      alert('Molimo vas upišite vrijednosti za filtere pretrage!');
      if (spin != null && zoom != null) {
        spin.setAttribute("hidden", "true");
        zoom.setAttribute("hidden", "true");
      }
    }
    else {
      const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
      const options = {
        method: 'GET',
        withCredentials: true,
        headers: {
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          ClientId: clientId,
          Authorization: accessToken,
        },
      }
      var endpoint = `${host}/inquiry/getCodeBookById?RetrieveAll=true&`;
      // var endpoint = `${host}/Inquiry/GetAccount?RetrieveAll=true&`;
      if (LongName !== '') {
        endpoint = endpoint + 'LongNameCodeBook=' + LongName + '&';
      }
      if (ShortName !== '') {
        endpoint = endpoint + 'ShortNameCodeBook=' + ShortName + '&';
      }
      if (Address !== '') {
        endpoint = endpoint + 'Address=' + Address + '&';
      }
      authFetch(
        endpoint,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then(
          (result) => {
            if (result !== null && result !== undefined) {
              for (var i = 0; i < result.length; i++) {

                CodeBookArray.push(result[i] as CodeBook)

              }
            }

            fillCodeBookArray([...CodeBookArray])
            if (result.length === 0) {
              setShowNoResultMessage('0');
              showToastMessage();
            }



            MenuComponent.reinitialization()

            if (spin != null && zoom != null) {
              spin.setAttribute("hidden", "true");
              zoom.removeAttribute("hidden");
            }
          },
          (error) => {
            return []
          }

        )
    }

  }


  const codeBookView = () => {


    return <div className={`card ${className}`} style={{ padding: "0%", width: "100%" }} >
      <div className='col-xxl-12' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
        <div className='card-header align-items-center border-0 mt-4' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>

          <div className='input-group'>

            <div className='col-3 col-sm-3 col-lg-6' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <h3 className='card-title align-items-start flex-column' style={{ paddingLeft: "1%" }} >
                  <span className='fw-bolder mb-2 text-dark'>
                    {intl.formatMessage({ id: 'CODEBOOK.ADDANDEDIT' })}
                  </span>
                </h3>
              </div>
            </div>
            <div className='col-3 col-sm-3 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='fw-bolder mb-2 text-dark'>

                  </span>
                </h3>
              </div>
            </div>
          </div>




          <div className='input-group' style={{ marginLeft: "1%" }}>
            <div className='col-3 col-sm-2 col-lg-3' style={{ paddingTop: "1%", paddingRight: "1%" }}>


              <input
                value={LongName}
                onChange={onChangeLongName}
                onKeyDown={onKeyDownHandler}
                type='text'
                data-kt-customer-table-filter='search'
                className='form-control form-control-solid ps-3'
                placeholder={intl.formatMessage({ id: 'CODEBOOK.DUZINAZIV' })}
                required
                title="Unijeti duži naziv za šifarnik"
              />

            </div>
            <div className='col-3 col-sm-2 col-lg-3' style={{ paddingTop: "1%", paddingRight: "1%" }}>



              <input
                value={ShortName}
                onChange={onChangeShortName}
                onKeyDown={onKeyDownHandler}
                type='text'
                data-kt-customer-table-filter='search'
                className='form-control form-control-solid ps-3'
                placeholder={intl.formatMessage({ id: 'CODEBOOK.KRACINAZIV' })}
                required
                title="Unijeti kraći naziv za šifarnik"
              />

            </div>
            <div className='col-3 col-sm-2 col-lg-3' style={{ paddingTop: "1%", paddingRight: "1%" }}>



              <input
                value={Address}
                onChange={onChangeAddress}
                onKeyDown={onKeyDownHandler}
                type='text'
                data-kt-customer-table-filter='search'
                className='form-control form-control-solid ps-3'
                placeholder={intl.formatMessage({ id: 'CODEBOOK.ADRESA' })}
                required
                title="Unijeti adresu za šifarnik"
              />

            </div>

          </div>



          <div className='input-group'>



            <div className='col-3 col-sm-3 col-lg-3' style={{ paddingBottom: "1%", paddingLeft: "0.3%", paddingTop: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-1'>
                <button className='btn btn-secondary my-1' onClick={resetInputField} style={{ backgroundColor: "#cd513d", color: 'white', width: "100%", marginLeft: "2%" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M14.5 20.7259C14.6 21.2259 14.2 21.826 13.7 21.926C13.2 22.026 12.6 22.0259 12.1 22.0259C9.5 22.0259 6.9 21.0259 5 19.1259C1.4 15.5259 1.09998 9.72592 4.29998 5.82592L5.70001 7.22595C3.30001 10.3259 3.59999 14.8259 6.39999 17.7259C8.19999 19.5259 10.8 20.426 13.4 19.926C13.9 19.826 14.4 20.2259 14.5 20.7259ZM18.4 16.8259L19.8 18.2259C22.9 14.3259 22.7 8.52593 19 4.92593C16.7 2.62593 13.5 1.62594 10.3 2.12594C9.79998 2.22594 9.4 2.72595 9.5 3.22595C9.6 3.72595 10.1 4.12594 10.6 4.02594C13.1 3.62594 15.7 4.42595 17.6 6.22595C20.5 9.22595 20.7 13.7259 18.4 16.8259Z" fill="currentColor" />
                    <path opacity="0.3" d="M2 3.62592H7C7.6 3.62592 8 4.02592 8 4.62592V9.62589L2 3.62592ZM16 14.4259V19.4259C16 20.0259 16.4 20.4259 17 20.4259H22L16 14.4259Z" fill="currentColor" />
                  </svg>
                  <span className="pl-5">
                    {intl.formatMessage({ id: 'ACCOUNT.CLEAR' })}{' '}
                  </span>
                </button>
              </div>
            </div>

            <div className='col-3 col-sm-3 col-lg-3' style={{ paddingBottom: "1%", paddingTop: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-2'>
                <button
                  type='submit'
                  className='btn btn-secondary my-1'
                  onClick={() => getCodeBook()}
                  style={{ width: "100%", background: "#009ef7", color: "white", marginLeft: "0.5%" }}

                >
                  <svg id="search-zoom" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
                    <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor" />
                  </svg>
                  <span id="search-spin" hidden className="spinner-border spinner-border-sm align-middle"></span>
                  <span className="pl-5">
                    {intl.formatMessage({ id: 'CODEBOOK.SEARCH' })}{' '}
                  </span>
                </button>
              </div>
            </div>

            <div className='col-3 col-sm-3 col-lg-3' style={{ paddingBottom: "1%", paddingTop: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-2'>
                <button
                  type='submit'
                  className='btn btn-secondary my-1'
                  onClick={() => addCodeBook(LongName, ShortName, Address)}
                  style={{ width: "100%", backgroundColor: "#009ef7", color: "white", marginRight: "1%" }}
                >
                  <svg id="add-zoom" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">

                  </svg>

                  <span className="pl-5">
                    {intl.formatMessage({ id: 'CODEBOOK.ADD' })}{' '}
                  </span>
                </button>
              </div>
            </div>
            <div className='col-3 col-sm-3 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1 mx-3'>

              </div>
            </div>

            <ToastContainer />




          </div>

        </div>
      </div >

      {

        //source_array.length > 0
        CodeArray.length > 0
          ?
          (

            /* <TablesWidgetInquiry className='col-xxl-12' parentToChild={source_array} />*/
            < TablesCodeBookBba className='col-xxl-12' parentToChild={CodeArray} username={user.username} codeBookHost={host + '/CodeBookBba'} allowParam={true} />
          )
          :
          (showNoResultMessage === '0') ? (
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {intl.formatMessage({ id: 'ACCOUNT.NORESULTS' })}
                </span>
              </h3>
            </div>
          ) : (
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-bold fs-7'>

                </span>
              </h3>
            </div>
          )

      }



    </div >
  }
  return codeBookView();

}





export { CodeBookBbaAddAndSearch }


